import React, { useState } from 'react';

import { Link } from 'react-router-dom';
/// Scroll
import PerfectScrollbar from 'react-perfect-scrollbar';

/// Image
import profile from '@images/user.jpg';
import avatar from '@images/avatar/1.jpg';
import { Dropdown } from 'react-bootstrap';
import LogoutPage from './Logout';

const Header = ({ onNote }) => {
  const [searchBut, setSearchBut] = useState(false);
  var path = window.location.pathname.split('/');
  var name = path[path.length - 1].split('-');
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;

  return (
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: 'capitalize' }}
              >
                {filterName.join(' ').length === 0
                  ? 'Introduction'
                  : filterName.join(' ') === 'dashboard dark'
                  ? 'Introduction'
                  : filterName.join(' ')}
              </div>
            </div>
            <div>
              <LogoutPage />
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
